export interface Upsell {
  slug: string;
}

export interface UpsellStep {
  title: string;
  count: number;
}

export enum UpsellExperienceVariant {
  Original = 'original',
  InterstitialOne = 'interstitialOne'
}
